import { POSITIONS } from "../consts";
export var isPositionLeft = function isPositionLeft(p) {
  return p === POSITIONS.LEFT;
};
export var isPositionRight = function isPositionRight(p) {
  return p === POSITIONS.RIGHT;
};
export var isPositionBottom = function isPositionBottom(p) {
  return p === POSITIONS.BOTTOM;
};
export var isPositionTop = function isPositionTop(p) {
  return p === POSITIONS.TOP;
};
export var isVertical = function isVertical(p) {
  return isPositionTop(p) || isPositionBottom(p);
};
export var isHorizontal = function isHorizontal(p) {
  return isPositionLeft(p) || isPositionRight(p);
};